import { Toast } from "@materialstyle/materialstyle";

export const notification = {
  _toast: null,
  message: "",
  header: "",

  init() {
    if (this._toast !== null) {
      return;
    }

    const el = document.getElementById("appNotification");
    this._toast = new Toast(el);
  },

  show(header, message) {
    if (!this._toast) {
      this.init();
    }

    this.message = message;
    this.header = header;
    this._toast.show();
  },
};
